import dayjs, { type Dayjs } from 'dayjs';

/** 与 server `redo-window.util` 的 REDO_WINDOW_DAYS 一致：提交当天计入，再保留 7 天 */
export const REDO_WINDOW_DAYS = 7;

/** 这一刻起从隔天重做列表摘掉。提交日往后第 8 天的 0 点 */
export function getRedoRemoveAt(submitTime: string): Dayjs {
  return dayjs(submitTime).startOf('day').add(REDO_WINDOW_DAYS + 1, 'day');
}

/** 剩余时间，例如「还剩 3 天」「还剩 4时50分」。已过期返回 null */
export function formatRedoCountdown(
  submitTime: string | undefined,
  now: string | Dayjs = dayjs(),
): string | null {
  if (!submitTime) return null;
  const remainingMs = getRedoRemoveAt(submitTime).diff(dayjs(now));
  if (remainingMs <= 0) return null;

  const totalMinutes = Math.floor(remainingMs / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  if (days >= 1) return `还剩 ${days} 天`;
  if (hours >= 1) return minutes > 0 ? `还剩 ${hours}时${minutes}分` : `还剩 ${hours} 小时`;
  if (minutes >= 1) return `还剩 ${minutes} 分`;
  return '即将摘掉';
}
